export class ScrollHelper {
  static readonly SECTION_ANCHOR = 'section-anchor';

  static scrollToSection(elementId: string): void{
    const el = document.getElementById(elementId);
    const scrollableParent = document.querySelector('main');
    const elementPosition = el.getBoundingClientRect().top;
    const parentPosition = scrollableParent.getBoundingClientRect().top;
    scrollableParent.scrollTo({
      top: scrollableParent.scrollTop + elementPosition - parentPosition - 60,
      behavior: 'smooth'
    });
  }
}
